'use client'

import Link from 'next/link'
import { useState } from 'react'
import { LinkType } from '@/lib/api-connector-strapi-cms/api/reeve-landing-page/reeveLandingPageApi.types'

interface ButtonProps {
  link: string
  type: LinkType
  label: string
}

export default function RandomColorButton({ link, type, label }: ButtonProps) {
  const hoverColors = [
    '#85c8ff', // Light blue
    '#ffa422', // Orange
    '#d1e454', // Light green
    '#c1bbfe', // Light purple
    '#ffd12f', // Yellow
  ]

  const [isHovered, setIsHovered] = useState(false)
  const [currentColor, setCurrentColor] = useState(hoverColors[0])

  const getRandomColor = (currentColor: string) => {
    const availableColors = hoverColors.filter(
      (color) => color !== currentColor,
    )
    return availableColors[Math.floor(Math.random() * availableColors.length)]
  }

  const handleMouseEnter = () => {
    const newColor = getRandomColor(currentColor)
    setCurrentColor(newColor)
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <div className="flex items-center justify-center">
      <Link
        href={link}
        target={type === LinkType.EXTERNAL ? '_blank' : undefined}
        className="rounded-md px-6 py-2 font-medium transition-all duration-200 ease-in-out"
        style={{
          backgroundColor: isHovered ? currentColor : '#000b31',
          color: isHovered ? '#000b31' : '#ffffff',
          transform: isHovered ? 'scale(1.05)' : 'scale(1)',
          minWidth: isHovered ? '140px' : '100px',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="flex w-full items-center justify-center">
          <div className="inline-flex items-center justify-center">
            <span>{label}</span>
            <span
              className="flex items-center overflow-hidden transition-all duration-200 ease-in-out"
              style={{
                maxWidth: isHovered ? '24px' : '0',
                opacity: isHovered ? 1 : 0,
                marginLeft: isHovered ? '8px' : '0',
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.43 18.82C14.24 18.82 14.05 18.75 13.9 18.6C13.61 18.31 13.61 17.83 13.9 17.54L19.44 12L13.9 6.46C13.61 6.17 13.61 5.69 13.9 5.4C14.19 5.11 14.67 5.11 14.96 5.4L21.03 11.47C21.32 11.76 21.32 12.24 21.03 12.53L14.96 18.6C14.81 18.75 14.62 18.82 14.43 18.82Z"
                  fill="#000B31"
                />
                <path
                  d="M20.33 12.75H3.5C3.09 12.75 2.75 12.41 2.75 12C2.75 11.59 3.09 11.25 3.5 11.25H20.33C20.74 11.25 21.08 11.59 21.08 12C21.08 12.41 20.74 12.75 20.33 12.75Z"
                  fill="#000B31"
                />
              </svg>
            </span>
          </div>
        </div>
      </Link>
    </div>
  )
}
